
const map1Text = [
  {
    name: 'one',
    children: [
      { name: '海布拉地区', latlng: [-31.80289258670676, -43.24218750000001], zoom: 3 },
      { name: '中央海拉鲁', latlng: [-65.29346780107583, 20.566406250000004], zoom: 3 },
      { name: '奥尔汀地区', latlng: [-38.95940879245423, 65.21484375000001], zoom: 3 },
      { name: '阿卡莱地区', latlng: [-26.43122806450644, 95.09765625000001], zoom: 3 },
      { name: '拉聂尔地区', latlng: [-68.26938680456564, 87.36328125000001], zoom: 3 },
      { name: '哈特尔地区', latlng: [-75.27541260821626, 76.99218750000001], zoom: 3 },
      { name: '格鲁德地区', latlng: [-81.22826656005543, -53.61328125000001], zoom: 3 },
      { name: '费罗尼地区', latlng: [-80.297927149974, 44.47265625000001], zoom: 3 }
    ]
  },
  {
    name: 'two',
    children: [
      { name: '阿卡莱海', latlng: [-18.020527657852327, 118.30078125000001], zoom: 5 },
      { name: '深远阿卡莱', latlng: [-22.958393318086348, 94.921875], zoom: 5 },
      { name: '阿卡莱高原', latlng: [-38.754083275791416, 92.59277343750001], zoom: 5 },
      { name: '一始村', latlng: [-48.516604348867475, 101.6015625], zoom: 5 },
      { name: '死亡之山', latlng: [-34.705493410225465, 74.09179687500001], zoom: 5 },
      { name: '鼓隆城', latlng: [-35.42486791930557, 57.21679687500001], zoom: 5 },
      { name: '奥尔汀峡谷', latlng: [-50.14874640066278, 60.60058593750001], zoom: 5 },
      { name: '奥尔汀山脉', latlng: [-19.808054128088575, 49.96582031250001], zoom: 5 },
      { name: '卓拉领地', latlng: [-60.23981116999893, 88.76953125], zoom: 5 },
      { name: '拉聂尔大水源', latlng: [-65.09064558256853, 93.33984375000001], zoom: 5 },
      { name: '拉聂尔海', latlng: [-62.83508901142283, 111.75292968750001], zoom: 5 },
      { name: '拉聂尔山', latlng: [-72.58082870324515, 100.10742187500001], zoom: 5 },
      { name: '卡卡利科村', latlng: [-71.56664127895979, 59.89746093750001], zoom: 5 },
      { name: '西哈特尔', latlng: [-74.72961516378618, 51.24023437500001], zoom: 5 },
      { name: '拉聂尔湿地', latlng: [-64.830253743883, 60.99609375000001], zoom: 5 },
      { name: '哈特尔海', latlng: [-80.0504595230276, 104.0625], zoom: 5 },
      { name: '哈特诺村', latlng: [-77.24477980765316, 92.98828125], zoom: 5 },
      { name: '东哈特尔', latlng: [-78.92083162470739, 76.68457031250001], zoom: 5 },
      { name: '海利亚湖', latlng: [-78.6991059255054, 23.203125000000004], zoom: 5 },
      { name: '费罗尼草原', latlng: [-80.9422727563339, 17.622070312500004], zoom: 5 },
      { name: '费罗尼海', latlng: [-83.1110709962606, 24.213867187500004], zoom: 5 },
      { name: '海拉鲁平原', latlng: [-68.76823505122316, 16.259765625000004], zoom: 5 },
      { name: '监视堡垒', latlng: [-64.20637724320851, 20.390625000000004], zoom: 5 },
      { name: '克洛格森林', latlng: [-41.244772343082076, 33.53027343750001], zoom: 5 },
      { name: '海拉鲁大森林', latlng: [-33.7243396617476, 32.69531250000001], zoom: 5 },
      { name: '塔邦挞大雪原', latlng: [-25.641526373065755, -8.789062500000002], zoom: 5 },
      { name: '海布拉山脉', latlng: [-26.470573022375085, -33.44238281250001], zoom: 5 },
      { name: '利特村', latlng: [-44.90257799628887, -44.0771484375], zoom: 5 },
      { name: '塔邦挞边境', latlng: [-52.26815737376817, -42.75878906250001], zoom: 5 },
      { name: '海拉鲁丘陵', latlng: [-61.01572481397616, -20.874023437500004], zoom: 5 },
      { name: '格鲁德高地', latlng: [-70.55417853776078, -52.86621093750001], zoom: 5 },
      { name: '格鲁德小镇', latlng: [-80.20865220938808, -48.60351562500001], zoom: 5 },
      { name: '格鲁德沙漠', latlng: [-81.80502352078736, -44.60449218750001], zoom: 5 }
    ]
  },
  {
    name: 'three',
    children: [
      { name: '阿卡莱古代研究所', latlng: [-23.221154981846556, 111.66503906250001], zoom: 6 },
      { name: '北阿卡莱海岸', latlng: [-27.839076094777816, 115.99365234375001], zoom: 6 },
      { name: '秋叶台地', latlng: [-23.664650731631625, 105.3369140625], zoom: 6 },
      { name: '红叶湖', latlng: [-25.918526162075153, 107.49023437500001], zoom: 6 },
      { name: '北阿卡莱高地', latlng: [-27.33273513685913, 106.30371093750001], zoom: 6 },
      { name: '深远阿卡莱平原', latlng: [-19.9526963975442, 97.51464843750001], zoom: 6 },
      { name: '北阿卡莱平原', latlng: [-28.671310915880834, 98.10791015625001], zoom: 6 },
      { name: '骷髅池塘', latlng: [-17.35063837604883, 88.96728515625001], zoom: 6 },
      { name: '卡札那裂谷', latlng: [-21.350781150679722, 91.01074218750001], zoom: 6 },
      { name: '八爪怪森林', latlng: [-24.58709033920962, 89.6704101562500], zoom: 6 },
      { name: '八爪怪池塘', latlng: [-34.79576153473033, 103.60107421875001], zoom: 6 },
      { name: '奥尔龙盆地', latlng: [-33.63291573870477, 95.14160156250001], zoom: 6 },
      { name: '东阿卡莱海岸', latlng: [-35.2815006578912, 110.03906250000001], zoom: 6 },
      { name: '马秋兹半岛', latlng: [-38.873928539236296, 114.74121093750001], zoom: 6 },
      { name: '玛林湾', latlng: [-43.548548110912876, 109.97314453125001], zoom: 6 },
      { name: '夏特岭', latlng: [-38.06539235133248, 90.087890625], zoom: 6 },
      { name: '乌尔利山', latlng: [-40.58058466412763, 95.40527343750001], zoom: 6 },
      { name: '卡纳莱特高原', latlng: [-43.34116005412307, 88.92333984375001], zoom: 6 },
      { name: '塔林湿地', latlng: [-46.8301336404474, 94.04296875000001], zoom: 6 },
      { name: '一始村', latlng: [-47.68018294648414, 101.49169921875001], zoom: 6 },
      { name: '阿卡莱湖', latlng: [-49.00905080938206, 99.86572265625], zoom: 6 },
      { name: '阿卡莱堡垒遗迹', latlng: [-48.516604348867475, 88.92333984375001], zoom: 6 },
      { name: '南阿卡莱平原', latlng: [-50.541362965221616, 87.89062500000001], zoom: 6 },
      { name: '南阿卡莱湖', latlng: [-53.252068805894126, 94.61425781250001], zoom: 6 },
      { name: '南阿卡莱瀑布', latlng: [-52.789475581398875, 96.96533203125001], zoom: 6 },
      { name: '凯坡拉岭', latlng: [-51.63165734944998, 105.16113281250001], zoom: 6 },
      { name: '乌克克平原', latlng: [-54.90188218738499, 100.48095703125], zoom: 6 },
      { name: '奇克伦岛', latlng: [-50.77815527465924, 115.51025390625001], zoom: 6 },
      { name: '阿克伦岛', latlng: [-54.48280455958255, 114.43359375000001], zoom: 6 },
      { name: '纳克仑岛', latlng: [-56.71656572651469, 114.63134765625001], zoom: 6 },
      { name: '乌尔拉峡谷', latlng: [-56.48676175249086, 106.01806640625001], zoom: 6 },
      { name: '托托湖', latlng: [-55.71473455012691, 92.21923828125001], zoom: 6 },
      { name: '卓拉台地', latlng: [-55.57834467218206, 85.97900390625001], zoom: 6 },
      { name: '戴比岛', latlng: [-58.52812491190514, 114.19189155558477], zoom: 6 },
      { name: '雷兽山', latlng: [-58.35563011444189, 99.60204780558477], zoom: 6 },
      { name: '露露湖', latlng: [-58.73400452173256, 96.70165718058477], zoom: 6 },
      { name: '米考湖', latlng: [-58.98399078786474, 93.16405952433479], zoom: 6 },
      { name: '米法公园', latlng: [-59.26588038632406, 98.78905952433479], zoom: 6 },
      { name: '尝试海角', latlng: [-60.79134283763672, 97.38280952433477], zoom: 6 },
      { name: '卓拉领地', latlng: [-59.478568591504526, 89.38476264933477], zoom: 6 },
      { name: '卓拉大桥', latlng: [-61.67944981980615, 87.27538764933477], zoom: 6 },
      { name: '露朵湖', latlng: [-63.054959096136095, 86.19872749308477], zoom: 6 },
      { name: '露朵台地', latlng: [-62.103882301407644, 90.79101264933479], zoom: 6 },
      { name: '露朵山', latlng: [-63.44068618869895, 88.17626655558477], zoom: 6 },
      { name: '东部的储水湖', latlng: [-62.664054851493056, 95.80077827433477], zoom: 6 },
      { name: '茹特拉大坝', latlng: [-64.59561259720488, 93.91112983683477], zoom: 6 },
      { name: '加卜台地', latlng: [-64.82090691782787, 101.09618843058479], zoom: 6 },
      { name: '塔尔塔尔台地', latlng: [-61.01572458458031, 104.83153999308479], zoom: 6 },
      { name: '斯普尔湾', latlng: [-62.895217544882044, 109.95117187500001], zoom: 6 },
      { name: '萨玛莎平原', latlng: [-68.51214331858073, 88.37402343750001], zoom: 6 },
      { name: '布兰努山丘', latlng: [-67.25505812564364, 100.30517578125001], zoom: 6 },
      { name: '拉聂尔湾', latlng: [-68.72841343575509, 98.50341796875001], zoom: 6 },
      { name: '荷隆湾', latlng: [-66.81787214936938, 106.58935546875], zoom: 6 },
      { name: '托洛伊瓦高原', latlng: [-67.28901521116026, 110.43457031250001], zoom: 6 },
      { name: '罗德拉姆半岛', latlng: [-69.10777677331498, 110.91796875000001], zoom: 6 },
      { name: '塔姆海角', latlng: [-70.71447063199373, 111.4453125], zoom: 6 },
      { name: '文特岛', latlng: [-71.31487666166718, 112.14843750000001], zoom: 6 },
      { name: '洛塔托台地', latlng: [-70.42944002303408, 84.96826171875001], zoom: 6 },
      { name: '智慧之泉', latlng: [-73.34675920148594, 100.76660156250001], zoom: 6 },
      { name: '洁净池塘', latlng: [-73.25837557295397, 88.154296875], zoom: 6 },
      { name: '聂尔龙雪原', latlng: [-73.86761239709706, 92.63671875000001], zoom: 6 },
      { name: '卡伊更池塘', latlng: [-75.16892563137885, 86.74804687500001], zoom: 6 },
      { name: '拉聂尔群山', latlng: [-74.83343569581845, 102.59033203125001], zoom: 6 },
      { name: '玛德罗纳山', latlng: [-75.24746242005548, 98.59130859375], zoom: 6 },
      { name: '乌尔希池塘', latlng: [-76.21120505902486, 96.767578125], zoom: 6 },
      { name: '沃尔纳特山', latlng: [-76.27912201826652, 105.46875000000001], zoom: 6 },
      { name: '阿莫西亚海岸', latlng: [-75.86664560539866, 114.4775390625], zoom: 6 },
      { name: '基纳比森林', latlng: [-77.04927084349018, 86.83593750000001], zoom: 6 },
      { name: '塔尔荷池塘', latlng: [-77.63654163009745, 88.48388671875001], zoom: 6 },
      { name: '艾波尼山', latlng: [-78.76779175784321, 89.73632812500001], zoom: 6 },
      { name: '凯亚池塘', latlng: [-76.51169477901959, 92.5048828125], zoom: 6 },
      { name: '哈特诺村', latlng: [-77.24477980765316, 92.98828125], zoom: 6 },
      { name: '艾奇斯帕森林', latlng: [-76.68484630658422, 98.76708984375001], zoom: 6 },
      { name: '奇塔诺湾', latlng: [-78.59529919212491, 96.1962890625], zoom: 6 },
      { name: '哈特诺海滩', latlng: [-78.10735518561124, 102.61230468750001], zoom: 6 },
      { name: '哈特诺湾', latlng: [-78.51682718988943, 102.74414062500001], zoom: 6 },
      { name: '奥克诺湾', latlng: [-78.21554145519838, 107.88574218750001], zoom: 6 },
      { name: '独杉群山', latlng: [-77.56104173187532, 110.19287109375], zoom: 6 },
      { name: '卡艾德半岛', latlng: [-78.21105312560397, 114.69726562500001], zoom: 6 },
      { name: '哈特诺小岛', latlng: [-80.38639582973975, 102.37060546875001], zoom: 6 },
      { name: '米诺米诺湾', latlng: [-80.02384918671082, 91.34033203125001], zoom: 6 },
      { name: '达斯齐达山', latlng: [-81.04545975235521, 87.14355468750001], zoom: 6 },
      { name: '乌洛克海角', latlng: [-81.22826656005543, 94.52636718750001], zoom: 6 },
      { name: '托隆波海滩', latlng: [-82.11235524021947, 110.74218750000001], zoom: 6 },
      { name: '柯荷利特台地', latlng: [-82.54060382149495, 115.44433593750001], zoom: 6 },
      { name: '雅西诺海滩', latlng: [-81.92627291095364, 92.65869140625001], zoom: 6 },
      { name: '伊萨奇海角', latlng: [-82.33531318263397, 98.30566406250001], zoom: 6 },
      { name: '克莱西亚半岛', latlng: [-82.71539429823954, 90.87890625000001], zoom: 6 },
      { name: '恰加拉海滨', latlng: [-82.10330409843418, 86.55029296875001], zoom: 6 },
      { name: '林芭海滩', latlng: [-82.59177472442023, 86.13281250000001], zoom: 6 },
      { name: '科尔奈海滩', latlng: [-82.35287681763093, 82.57324218750001], zoom: 6 },
      { name: '库坦池塘', latlng: [-80.33488667580171, 76.75048828125001], zoom: 6 },
      { name: '乌奥谷', latlng: [-81.27171971824262, 72.72949218750001], zoom: 6 },
      { name: '腾图丘陵', latlng: [-81.65968514918798, 70.75195312500001], zoom: 6 },
      { name: '卡尔山', latlng: [-81.84563961065611, 74.48730468750001], zoom: 6 },
      { name: '亚玛比湖', latlng: [-82.13944685874176, 72.75146484375001], zoom: 6 },
      { name: '克拉里海滩', latlng: [-83.05284627115934, 74.26757812500001], zoom: 6 },
      { name: '勇萨米平原', latlng: [-80.25339090652375, 68.95019531250001], zoom: 6 },
      { name: '克拉尔湖', latlng: [-81.1440986566813, 63.61083984375001], zoom: 6 },
      { name: '罗达伊湖', latlng: [-80.85887488432991, 60.86425781250001], zoom: 6 },
      { name: '利贝拉树海', latlng: [-81.44340660802128, 61.32568359375001], zoom: 6 },
      { name: '布伊达湖', latlng: [-82.33824323729574, 60.84228515625001], zoom: 6 },
      { name: '阿拉伊索海岸', latlng: [-82.85064817916859, 62.33642578125001], zoom: 6 },
      { name: '科嘉奈亚池塘', latlng: [-80.297927149974, 82.39746093750001], zoom: 6 },
      { name: '希克里森林', latlng: [-78.43341771170695, 62.68798828125001], zoom: 6 },
      { name: '花柔莉亚山', latlng: [-79.69111700765036, 62.55615234375001], zoom: 6 },
      { name: '克洛伊达高地', latlng: [-78.98398886594948, 66.33544921875001], zoom: 6 },
      { name: '洛兹伍德山', latlng: [-77.65534600967777, 71.23535156250001], zoom: 6 },
      { name: '托西奇池塘', latlng: [-78.80624627112446, 71.36718750000001], zoom: 6 },
      { name: '席美达山', latlng: [-78.59529919212491, 74.44335937500001], zoom: 6 },
      { name: '泰尔美山', latlng: [-79.35553167589991, 73.21289062500001], zoom: 6 },
      { name: '拉贝拉湿地带', latlng: [-79.71860546904043, 71.85058593750001], zoom: 6 },
      { name: '马布尔德平原', latlng: [-77.90186121818542, 78.11279296875001], zoom: 6 },
      { name: '贾拉湖', latlng: [-77.57995914400348, 82.00195312500001], zoom: 6 },
      { name: '火莹台地', latlng: [-78.25586068450242, 82.08984375000001], zoom: 6 },
      { name: '多尔米森林', latlng: [-77.38470599304453, 85.31982421875001], zoom: 6 },
      { name: '茨卡耶台地', latlng: [-79.21253761972712, 80.31005859375], zoom: 6 },
      { name: '库罕池塘', latlng: [-79.50465973724714, 78.70605468750001], zoom: 6 },
      { name: '泰尔美岭', latlng: [-79.92439258647073, 77.2119140625], zoom: 6 },
      { name: '库斯湖', latlng: [-76.78065491639973, 84.13330078125001], zoom: 6 },
      { name: '奥布力平原', latlng: [-76.03201380959756, 84.61669921875001], zoom: 6 },
      { name: '默米河', latlng: [-76.47577254009317, 79.49707031250001], zoom: 6 },
      { name: '拉纳湖', latlng: [-77.04927084349018, 72.77343750000001], zoom: 6 },
      { name: '布冰嘉森林', latlng: [-77.13761179723427, 65.47851562500001], zoom: 6 },
      { name: '克罗切利平原', latlng: [-76.23213762438118, 66.73095703125001], zoom: 6 },
      { name: '塔莫沼泽', latlng: [-76.01078299822137, 63.50097656250001], zoom: 6 },
      { name: '卡琳高原', latlng: [-75.6558756288176, 75.38818359375], zoom: 6 },
      { name: '卡伊更高地', latlng: [-73.75735240210412, 86.30859375], zoom: 6 },
      { name: '觉醒山', latlng: [-73.95286613470562, 81.47460937500001], zoom: 6 },
      { name: '布莱德台地', latlng: [-74.74696664174384, 77.80517578125], zoom: 6 },
      { name: '拉聂尔高地', latlng: [-73.12494524712693, 81.62841796875001], zoom: 6 },
      { name: '法兰台地', latlng: [-72.94543114547506, 73.82812500000001], zoom: 6 },
      { name: '纳利夏高地', latlng: [-72.95831480630818, 62.55615234375001], zoom: 6 },
      { name: '波努鲁山地', latlng: [-72.08743247624157, 66.64306640625001], zoom: 6 },
      { name: '皮埃尔高地', latlng: [-71.21607526596131, 67.93945312500001], zoom: 6 },
      { name: '阔塔台地', latlng: [-68.72841343575509, 66.26953125000001], zoom: 6 },
      { name: '东部高台', latlng: [-70.20743570670632, 61.83105468750001], zoom: 6 },
      { name: '阿拉布平原', latlng: [-68.80004113882613, 75.62988281250001], zoom: 6 },
      { name: '拉聂尔台地', latlng: [-70.95969716686398, 79.69482421875], zoom: 6 },
      { name: '拉鲁特大桥', latlng: [-64.20637724320851, 84.462890625], zoom: 6 },
      { name: '拉尔斯池塘', latlng: [-62.03183469254472, 81.60644531250001], zoom: 6 },
      { name: '欧兰桥', latlng: [-64.45384948864441, 80.63964843750001], zoom: 6 },
      { name: '许愿河畔', latlng: [-63.63650359618479, 78.55224609375001], zoom: 6 },
      { name: '杜邦山脉', latlng: [-65.17380608397224, 77.78320312500001], zoom: 6 },
      { name: '卓拉河', latlng: [-60.973107109199404, 76.72851562500001], zoom: 6 },
      { name: '塔巴尔森林', latlng: [-62.319002786030914, 74.59716796875001], zoom: 6 },
      { name: '茹特拉河', latlng: [-65.82978060097157, 74.09179687500001], zoom: 6 },
      { name: '波奈湖', latlng: [-64.08180520696274, 65.43457031250001], zoom: 6 },
      { name: '米奥乌岛', latlng: [-65.35767693905089, 63.87451171875001], zoom: 6 },
      { name: '塞拉瀑布', latlng: [-60.031929699115615, 84.55078125], zoom: 6 },
      { name: '三叉山道', latlng: [-57.112385007934016, 76.31103515625001], zoom: 6 },
      { name: '贝莱谷', latlng: [-57.77451753559619, 68.37890625000001], zoom: 6 },
      { name: '丘萨茨湖', latlng: [-51.930718279312885, 67.74169921875001], zoom: 6 },
      { name: '中鼓湖', latlng: [-44.82470828230023, 67.96142578125001], zoom: 6 },
      { name: '盖洛湖', latlng: [-45.42929873257376, 71.89453125000001], zoom: 6 },
      { name: '幽芬湖', latlng: [-48.2246726495652, 73.47656250000001], zoom: 6 },
      { name: '贝弗岛', latlng: [-45.166547157856016, 77.23388671875], zoom: 6 },
      { name: '密兹达湖', latlng: [-51.344338660599234, 78.15673828125001], zoom: 6 },
      { name: '马尔鼓池塘', latlng: [-39.808536041445905, 65.78613281250001], zoom: 6 },
      { name: '马尔鼓坑道', latlng: [-41.80407814427235, 64.42382812500001], zoom: 6 },
      { name: '达鲁波池塘', latlng: [-41.244772343082076, 70.53222656250001], zoom: 6 },
      { name: '死亡破火山口', latlng: [-26.31311263768267, 73.69628906250001], zoom: 6 },
      { name: '达鲁马湖', latlng: [-25.46311452925943, 63.23730468750001], zoom: 6 },
      { name: '奥尔汀台地', latlng: [-13.966054081318314, 69.01611328125001], zoom: 6 },
      { name: '埃文坡高地', latlng: [-13.282718975529793, 32.409668434853636], zoom: 6 },
      { name: '东埃文坡高地', latlng: [-13.966054095909453, 46.669922341103636], zoom: 6 },
      { name: '蟹蟹岛', latlng: [-24.26699728841817, 55.107421875], zoom: 6 },
      { name: '达鲁尼亚湖', latlng: [-28.555576049185973, 51.70166015625001], zoom: 6 },
      { name: '德依布朗遗迹', latlng: [-23.865745352647966, 31.838378906250004], zoom: 6 },
      { name: '玛科莱湖', latlng: [-30.164126343161097, 31.860351562500004], zoom: 6 },
      { name: '鼓洛斯湖', latlng: [-34.74161249883172, 61.25976562500001], zoom: 6 },
      { name: '鼓隆温泉', latlng: [-37.96152331396614, 59.54589843750001], zoom: 6 },
      { name: '鼓隆城', latlng: [-35.42486791930557, 57.21679687500001], zoom: 6 },
      { name: '托洛鼓悬崖', latlng: [-43.739352079154706, 60.84228515625001], zoom: 6 },
      { name: '米奇奇河', latlng: [-33.74261277734688, 53.61328125000001], zoom: 6 },
      { name: '鼓大河', latlng: [-44.762336674810996, 55.89843750000001], zoom: 6 },
      { name: '米德沼泽', latlng: [-36.20882309283712, 40.84716796875001], zoom: 6 },
      { name: '迷途森林', latlng: [-42.73087427928483, 40.12207031250001], zoom: 6 },
      { name: '克洛格森林', latlng: [-41.244772343082076, 33.53027343750001], zoom: 6 },
      { name: '鼓大湖', latlng: [-48.57478991092885, 59.56787109375001], zoom: 6 },
      { name: '贝莱平原', latlng: [-55.49130362820422, 51.416015625], zoom: 6 },
      { name: '鲁皮湖', latlng: [-52.789475581398875, 48.33984375], zoom: 6 },
      { name: '齐洛利森林', latlng: [-48.487486479884126, 45.79101562500001], zoom: 6 },
      { name: '海拉鲁军事演习场遗迹', latlng: [-49.8096315635631, 42.71484375000001], zoom: 6 },
      { name: '劳鲁丘陵', latlng: [-48.01932418480118, 34.56298828125001], zoom: 6 },
      { name: '更格尔山丘', latlng: [-55.936894769039434, 38.89160156250001], zoom: 6 },
      { name: '泽罗池塘', latlng: [-59.512029386502704, 56.75537109375001], zoom: 6 },
      { name: '迈尔卡岛', latlng: [-63.10469974712108, 58.29345703125001], zoom: 6 },
      { name: '杜艾斯岛', latlng: [-65.29346780107583, 58.16162109375], zoom: 6 },
      { name: '库尔德岛', latlng: [-66.04479639610696, 60.53466796875001], zoom: 6 },
      { name: '萨乌兹岛', latlng: [-65.53117097417716, 53.23974609375001], zoom: 6 },
      { name: '更格尔山', latlng: [-61.16443708638272, 48.01025390625001], zoom: 6 },
      { name: '苹果森林', latlng: [-62.14497603754045, 36.49658203125001], zoom: 6 },
      { name: '罗玛尼平原', latlng: [-61.16443708638272, 31.135253906250004], zoom: 6 },
      { name: '海利亚河', latlng: [-58.22859613248145, 31.904296875000004], zoom: 6 },
      { name: '维斯岛', latlng: [-66.70516871330432, 52.20703125000001], zoom: 6 },
      { name: '科彭嘉岛', latlng: [-67.01600934917995, 55.01953125000001], zoom: 6 },
      { name: '波浓岛', latlng: [-67.15289820820027, 59.50195312500001], zoom: 6 },
      { name: '神庙岛', latlng: [-67.67608458198099, 57.04101562500001], zoom: 6 },
      { name: '千之中州', latlng: [-68.23682270936281, 50.27343750000001], zoom: 6 },
      { name: '利科纳半岛', latlng: [-69.426690529672, 56.25000000000001], zoom: 6 },
      { name: '特洽湖', latlng: [-69.94537515128901, 58.31542968750001], zoom: 6 },
      { name: '环卡遗迹', latlng: [-70.64176873584623, 59.98535156250001], zoom: 6 },
      { name: '卡卡利科村', latlng: [-71.56664127895979, 59.89746093750001], zoom: 6 },
      { name: '哈格罗莫湖', latlng: [-71.28669893545877, 58.35937500000001], zoom: 6 },
      { name: '撒哈斯拉平原', latlng: [-71.78768067220724, 50.62500000000001], zoom: 6 },
      { name: '纳比湖', latlng: [-72.52153150689024, 46.45019531250001], zoom: 6 },
      { name: '花之中州', latlng: [-70.36309108461556, 41.74804687500001], zoom: 6 },
      { name: '海利亚河', latlng: [-67.90035413006103, 41.55029296875001], zoom: 6 },
      { name: '无底池塘', latlng: [-68.75231494434473, 35.37597656250001], zoom: 6 },
      { name: '莫尔赛湖', latlng: [-72.77057418574792, 36.18896484375001], zoom: 6 },
      { name: '谢拉湖', latlng: [-73.58437794241054, 56.44775390625001], zoom: 6 },
      { name: '梅布尔高原', latlng: [-74.00744028988518, 51.08642578125001], zoom: 6 },
      { name: '双子山', latlng: [-75.93088543216642, 51.15234375], zoom: 6 },
      { name: '南纳比湖', latlng: [-74.80466599405533, 41.98974609375], zoom: 6 },
      { name: '诺凯河', latlng: [-75.61772069705145, 43.08837890625001], zoom: 6 },
      { name: '包美尔高地', latlng: [-75.61772069705145, 32.71728515625001], zoom: 6 },
      { name: '阿德亚村遗迹', latlng: [-76.45005633358495, 32.25585937500001], zoom: 6 },
      { name: '阿德亚湖', latlng: [-76.71517509237201, 34.03564453125001], zoom: 6 },
      { name: '泡泡拉高地', latlng: [-77.39430022245843, 39.94628906250001], zoom: 6 },
      { name: '安吉尔台地', latlng: [-79.07597677352747, 58.18359375], zoom: 6 },
      { name: '乌拉伊特湖', latlng: [-80.22731799413167, 59.54589843750001], zoom: 6 },
      { name: '花柔莉亚大瀑布', latlng: [-81.24500465654668, 59.26025390625001], zoom: 6 },
      { name: '花柔莉亚桥', latlng: [-81.79875708305215, 58.73291015625001], zoom: 6 },
      { name: '路特斯湖', latlng: [-80.73942311286706, 57.52441406250001], zoom: 6 },
      { name: '亚哲台地', latlng: [-78.65164410346163, 54.55810546875001], zoom: 6 },
      { name: '奇希莱平原', latlng: [-80.02765497223292, 54.16259765625001], zoom: 6 },
      { name: '卡玛斯台地', latlng: [-80.40106272066014, 52.51464843750001], zoom: 6 },
      { name: '本拉斯树海', latlng: [-81.21820846612178, 52.88818359375001], zoom: 6 },
      { name: '比托谷', latlng: [-78.94613731790122, 50.71289062500001], zoom: 6 },
      { name: '花柔莉亚河', latlng: [-81.41721306630068, 49.85595703125001], zoom: 6 },
      { name: '撒戎树海', latlng: [-81.30499982340112, 46.82373046875], zoom: 6 },
      { name: '卡兹溜河', latlng: [-79.36364593916082, 44.60449218750001], zoom: 6 },
      { name: '卡兹溜湖', latlng: [-78.9039293885709, 42.97851562500001], zoom: 6 },
      { name: '达姆泽尔树海', latlng: [-79.48462865291766, 40.80322265625001], zoom: 6 },
      { name: '邦迈扎湖', latlng: [-80.00861166231621, 42.60498046875], zoom: 6 },
      { name: '古奇尼扎平原', latlng: [-81.56029902660973, 41.39648437500001], zoom: 6 },
      { name: '恩古兰特树海', latlng: [-80.5897269130857, 38.16650390625001], zoom: 6 },
      { name: '费罗龙台地', latlng: [-78.76779175784321, 36.73828125000001], zoom: 6 },
      { name: '芬拉斯树海', latlng: [-80.38272563960413, 33.44238281250001], zoom: 6 },
      { name: '阿拉弗拉平原', latlng: [-81.4204916062904, 33.53027343750001], zoom: 6 },
      { name: '哈拉亚池塘', latlng: [-81.78620992719186, 32.47558593750001], zoom: 6 },
      { name: '巴尔麦平原', latlng: [-80.88675843015638, 29.707031250000004], zoom: 6 },
      { name: '花柔莉亚湖', latlng: [-82.00916921290778, 58.99658203125001], zoom: 6 },
      { name: '乌波茨台地', latlng: [-82.28238132963911, 56.00830078125], zoom: 6 },
      { name: '奇比纳湖', latlng: [-81.92009856891882, 44.6484375], zoom: 6 },
      { name: '马神湖', latlng: [-82.26465676240963, 37.46337890625001], zoom: 6 },
      { name: '伊巴拉高地', latlng: [-82.64540978981346, 40.45166015625], zoom: 6 },
      { name: '科莫莱海滩', latlng: [-83.14524798225757, 39.04541015625001], zoom: 6 },
      { name: '玛萨海湾', latlng: [-82.55485311272855, 48.73535156250001], zoom: 6 },
      { name: '阿米麦台地', latlng: [-82.2350258640378, 29.641113281250004], zoom: 6 },
      { name: '帕发海岸', latlng: [-82.84791302601151, 29.091796875], zoom: 6 },
      { name: '玛克米诺谷', latlng: [-81.70418745670518, 27.114257812500004], zoom: 6 },
      { name: '爱恩河', latlng: [-81.28504690079183, 23.88427734375], zoom: 6 },
      { name: '拉贝岩礁', latlng: [-82.8095114039649, 22.104492187500004], zoom: 6 },
      { name: '特托拉平原', latlng: [-81.37777346463592, 18.8525390625], zoom: 6 },
      { name: '奈兹坡树林', latlng: [-82.03965648920916, 18.698730468750004], zoom: 6 },
      { name: '卡萨伊美平原', latlng: [-82.4603052250356, 19.138183593750004], zoom: 6 },
      { name: '卡格萨群山', latlng: [-81.11020759735952, 15.732421875000002], zoom: 6 },
      { name: '泰荷塔湿地', latlng: [-82.79850188755617, 13.051757812500002], zoom: 6 },
      { name: '奥赛平原', latlng: [-81.98163149472781, 9.909667968750002], zoom: 6 },
      { name: '珊瑚', latlng: [-80.64703474739618, 24.389648437500004], zoom: 6 },
      { name: '泰格利平原', latlng: [-80.30533023671812, 10.305175781250002], zoom: 6 },
      { name: '卡坡莱山', latlng: [-79.17958765778233, 7.382812500000001], zoom: 6 },
      { name: '奥布巴巴草地', latlng: [-79.40816521262417, 1.6479492187500002], zoom: 6 },
      { name: '海利亚岛', latlng: [-79.15894345219259, 19.094238281250004], zoom: 6 },
      { name: '海利亚河', latlng: [-75.44202936067158, 27.773437500000004], zoom: 6 },
      { name: '天望山丘', latlng: [-76.44490733708945, 24.6533203125], zoom: 6 },
      { name: '时之森林', latlng: [-74.44935750063424, 17.841796875000004], zoom: 6 },
      { name: '东部神殿遗迹', latlng: [-76.52706134250079, 15.468750000000002], zoom: 6 },
      { name: '精灵森林', latlng: [-75.30888448476102, 6.943359375000001], zoom: 6 },
      { name: '青蛙池塘', latlng: [-75.00494000767516, 2.5927734375000004], zoom: 6 },
      { name: '黄泉河', latlng: [-76.42429214465984, 0.7910156250000001], zoom: 6 },
      { name: '海利亚山', latlng: [-77.42782352730109, 0.3515625], zoom: 6 },
      { name: '草笛山丘', latlng: [-70.75796562654924, 29.311523437500004], zoom: 6 },
      { name: '风标草原', latlng: [-69.91521433690129, 12.260742187500002], zoom: 6 },
      { name: '交易所遗迹', latlng: [-70.64176873584623, 11.5576171875], zoom: 6 },
      { name: '科摩罗池塘', latlng: [-72.50172235139388, 16.347656250000004], zoom: 6 },
      { name: '亚阔湖', latlng: [-72.07391148820379, 5.800781250000001], zoom: 6 },
      { name: '达夫奈斯山', latlng: [-68.75231494434473, 4.482421875000001], zoom: 6 },
      { name: '麦贝草原', latlng: [-62.61356210229029, 27.685546875000004], zoom: 6 },
      { name: '东海拉鲁城邑遗迹', latlng: [-60.15244221438077, 24.9609375], zoom: 6 },
      { name: '中央广场遗迹', latlng: [-60.305185362827366, 20.434570312500004], zoom: 6 },
      { name: '西海拉鲁城邑遗迹', latlng: [-60.174306261926034, 15.468750000000002], zoom: 6 },
      { name: '海拉鲁城邑遗迹', latlng: [-61.37567331572748, 20.522460937500004], zoom: 6 },
      { name: '碎石场遗迹', latlng: [-60.37042901631508, 11.337890625], zoom: 6 },
      { name: '监视堡垒', latlng: [-63.52897054110279, 20.478515625000004], zoom: 6 },
      { name: '麦贝镇遗迹', latlng: [-65.6582745198266, 26.103515625000004], zoom: 6 },
      { name: '平原牧场遗迹', latlng: [-66.4957404570233, 27.773437500000004], zoom: 6 },
      { name: '鸟鸣草原', latlng: [-65.85675647909318, 14.194335937500002], zoom: 6 },
      { name: '古斯塔夫山', latlng: [-62.43107423292092, 7.294921875000001], zoom: 6 },
      { name: '卡洛克桥', latlng: [-59.95501026206206, 4.526367187500001], zoom: 6 },
      { name: '希麦加米河', latlng: [-63.13450320833446, 1.4501953125000002], zoom: 6 },
      { name: '巨人森林', latlng: [-65.23830662451155, 2.8125], zoom: 6 },
      { name: '主殿', latlng: [-53.90433815627469, 20.302734375000004], zoom: 6 },
      { name: '二殿', latlng: [-55.85064987433714, 22.104492187500004], zoom: 6 },
      { name: '三殿', latlng: [-56.218923189166624, 18.632812500000004], zoom: 6 },
      { name: '海拉鲁城堡护城河', latlng: [-51.31688050404586, 19.907226562500004], zoom: 6 },
      { name: '巴奇平原', latlng: [-48.60385760823253, 7.822265625000001], zoom: 6 },
      { name: '玛丽塔山丘', latlng: [-48.71996122264627, -0.0439453125], zoom: 6 },
      { name: '王室古代研究所遗迹', latlng: [-54.213861000644926, 1.0546875000000002], zoom: 6 },
      { name: '北海拉鲁平原', latlng: [-56.68037378950137, 0.6152343750000001], zoom: 6 },
      { name: '艾尔姆丘陵', latlng: [-45.120052841530544, 17.402343750000004], zoom: 6 },
      { name: '萨莉娅湖', latlng: [-42.97250158602596, 26.455078125000004], zoom: 6 },
      { name: '玛科莱岛', latlng: [-38.99357205820945, 20.258789062500004], zoom: 6 },
      { name: '阿尔达台地', latlng: [-41.54147766679029, 10.063476562500002], zoom: 6 },
      { name: '沃尔纳山', latlng: [-33.137551192346145, 14.150390625000002], zoom: 6 },
      { name: '沃尔纳高地', latlng: [-23.926013033021192, 17.622070312500004], zoom: 6 },
      { name: '西埃文坡高地', latlng: [-18.18760655249461, 26.3232421875], zoom: 6 },
      { name: '北塔邦挞雪原', latlng: [-20.097206227083888, -7.910156250000001], zoom: 6 },
      { name: '茨茨奇奇雪原', latlng: [-23.443088931121775, -18.984375000000004], zoom: 6 },
      { name: '拉明平原', latlng: [-40.780541431860314, 1.7578125000000002], zoom: 6 },
      { name: '忘却神殿', latlng: [-40.4469470596005, -5.009765625000001], zoom: 6 },
      { name: '南塔邦挞雪原', latlng: [-33.94335994657881, -10.239257812500002], zoom: 6 },
      { name: '柯库皮雪原', latlng: [-34.48844783780931, -19.555664062500004], zoom: 6 },
      { name: '玛丽塔平原', latlng: [-45.120052841530544, -6.987304687500001], zoom: 6 },
      { name: '拉不拉山', latlng: [-50.68079714532165, -12.304687500000002], zoom: 6 },
      { name: '拉不拉山丘', latlng: [-50.485473545784984, -17.314453125000004], zoom: 6 },
      { name: '库库甲谷', latlng: [-47.1897124644842, -18.764648437500004], zoom: 6 },
      { name: '塔邦挞村遗迹', latlng: [-43.421008829947255, -19.248046875000004], zoom: 6 },
      { name: '塔邦挞山丘', latlng: [-44.27667127377517, -22.32421875], zoom: 6 },
      { name: '终焉之谷', latlng: [-59.22093407615045, -2.9003906250000004], zoom: 6 },
      { name: '西海拉鲁平原', latlng: [-62.451405884537564, -6.328125000000001], zoom: 6 },
      { name: '齐纳嘉莱湿地带', latlng: [-57.938183012205315, -15.424804687500002], zoom: 6 },
      { name: '塞莱斯平原', latlng: [-60.58696734225869, -19.335937500000004], zoom: 6 },
      { name: '尼凯尔平原', latlng: [-68.47992564291268, -7.998046875000001], zoom: 6 },
      { name: '萨尔法山丘', latlng: [-70.51024068514326, -8.569335937500002], zoom: 6 },
      { name: '泰阿蒙河', latlng: [-64.86760781632728, -19.555664062500004], zoom: 6 },
      { name: '萨托利山', latlng: [-66.60067571342496, -18.105468750000004], zoom: 6 },
      { name: '卢驰尔湖', latlng: [-69.06856318696033, -23.4228515625], zoom: 6 },
      { name: '达拉伊特森林', latlng: [-71.6498329432346, -13.9306640625], zoom: 6 },
      { name: '奈弗拉高地', latlng: [-74.33110825221166, -15.776367187500002], zoom: 6 },
      { name: '娜波露山', latlng: [-76.25825951133778, -11.601562500000002], zoom: 6 },
      { name: '梅竹台地', latlng: [-75.59587329063447, -16.918945312500004], zoom: 6 },
      { name: '斯塔尔里台地', latlng: [-79.49665183507658, -5.185546875000001], zoom: 6 },
      { name: '亚娜谷', latlng: [-79.78116424879936, -10.634765625], zoom: 6 },
      { name: '格鲁德峡谷', latlng: [-77.61770905279674, -18.632812500000004], zoom: 6 },
      { name: '眼镜岩', latlng: [-78.80197997387756, -17.446289062500004], zoom: 6 },
      { name: '摩尔迦娜山', latlng: [-81.64054024275906, -1.4941406250000002], zoom: 6 },
      { name: '摩尔达巴山', latlng: [-82.1903678749072, -1.40625], zoom: 6 },
      { name: '东格鲁德高地', latlng: [-80.40106272066014, -5.405273437500001], zoom: 6 },
      { name: '贝立德关卡', latlng: [-81.02491605035449, -13.535156250000002], zoom: 6 },
      { name: '东格鲁德', latlng: [-82.08214461298606, -22.9833984375], zoom: 6 },
      { name: '南部绿洲', latlng: [-82.21421714106775, -46.2744140625], zoom: 6 },
      { name: '北格鲁德巨石', latlng: [-77.86034459764656, -38.45214843750001], zoom: 6 },
      { name: '沙漠的裂缝', latlng: [-79.47259186286934, -42.31933593750001], zoom: 6 },
      { name: '帕鲁荒原', latlng: [-80.46678988319272, -35.06835937500001], zoom: 6 },
      { name: '北格鲁德遗迹', latlng: [-79.05513728566137, -46.88964843750001], zoom: 6 },
      { name: '格鲁德小镇', latlng: [-80.20865220938808, -48.60351562500001], zoom: 6 },
      { name: '基尔克台地', latlng: [-74.48466225015636, -25.312500000000004], zoom: 6 },
      { name: '澳尔帕台地', latlng: [-72.6595884687862, -30.849609375000004], zoom: 6 },
      { name: '塔菲亚高地', latlng: [-75.83441802215226, -28.959960937500004], zoom: 6 },
      { name: '萨菲亚斯台地', latlng: [-74.49641311694309, -35.50781250000001], zoom: 6 },
      { name: '查波雪原', latlng: [-72.15488958260748, -41.79199218750001], zoom: 6 },
      { name: '比利丁高地', latlng: [-76.01609366420996, -41.92382812500001], zoom: 6 },
      { name: '瓦舒阿山丘', latlng: [-65.09064558256853, -27.509765625000004], zoom: 6 },
      { name: '伊露美娜台地', latlng: [-64.35893097894458, -34.58496093750001], zoom: 6 },
      { name: '伊露美娜池塘', latlng: [-65.36683689226321, -42.71484375000001], zoom: 6 },
      { name: '马克雅林高地', latlng: [-68.98992503056702, -39.8583984375], zoom: 6 },
      { name: '罗姆山', latlng: [-56.92099675839106, -26.586914062500004], zoom: 6 },
      { name: '吉希山丘', latlng: [-57.938183012205315, -41.08886718750001], zoom: 6 },
      { name: '路茨平原', latlng: [-60.08676274626006, -46.1865234375], zoom: 6 },
      { name: '吉萨山丘', latlng: [-55.00282580979324, -44.25292968750001], zoom: 6 },
      { name: '哈希毕罗湖', latlng: [-51.6180165487737, -39.33105468750001], zoom: 6 },
      { name: '莫里桥', latlng: [-50.98609893339355, -34.49707031250001], zoom: 6 },
      { name: '库荷山', latlng: [-51.041393898126366, -48.42773437500001], zoom: 6 },
      { name: '塔玛湖', latlng: [-43.10098287618853, -31.420898437500004], zoom: 6 },
      { name: '海布拉湖', latlng: [-40.4469470596005, -34.40917968750001], zoom: 6 },
      { name: '海布拉河', latlng: [-36.985003092855955, -27.421875000000004], zoom: 6 },
      { name: '利特村', latlng: [-44.90257799628887, -44.0771484375], zoom: 6 },
      { name: '利利特特湖', latlng: [-42.71473218539458, -44.12109375], zoom: 6 },
      { name: '利诺斯岭', latlng: [-37.89219554724435, -48.12011718750001], zoom: 6 },
      { name: '海布拉水源', latlng: [-34.88593094075316, -29.663085937500004], zoom: 6 },
      { name: '卡斯拉山', latlng: [-35.6037187406973, -37.52929687500001], zoom: 6 },
      { name: '卡尔加岭', latlng: [-36.63316209558656, -45.43945312500001], zoom: 6 },
      { name: '海布拉山南岳', latlng: [-32.99023555965107, -41.66015625000001], zoom: 6 },
      { name: '夏利巴山', latlng: [-31.165809587861947, -35.41992187500001], zoom: 6 },
      { name: '暴风谷', latlng: [-27.68352808378776, -33.83789062500001], zoom: 6 },
      { name: '海布拉山山顶', latlng: [-27.68352808378776, -27.993164062500004], zoom: 6 },
      { name: '海布拉山东岳', latlng: [-24.407137917727653, -28.037109375000004], zoom: 6 },
      { name: '丝莱米的小屋', latlng: [-23.88583769986199, -32.12402343750001], zoom: 6 },
      { name: '海布拉冻原', latlng: [-22.06527806776582, -39.90234375000001], zoom: 6 },
      { name: '比隆雪原', latlng: [-26.667095801104804, -46.75781250000001], zoom: 6 },
      { name: '海布拉北峰', latlng: [-12.340001834116316, -42.93457031250001], zoom: 6 },
      { name: '海布拉山北岳', latlng: [-14.817370620155266, -52.42675781250001], zoom: 6 },
      { name: '冰冻山麓', latlng: [-11.566143767762856, -57.70019531250001], zoom: 6 },
      { name: '海布拉山西岳', latlng: [-22.836945920943855, -60.02929687500001], zoom: 6 },
      { name: '乌克池塘', latlng: [-36.24427318493909, -53.65722656250001], zoom: 6 },
      { name: '巴美山丘', latlng: [-47.398349200359256, -51.50390625000001], zoom: 6 },
      { name: '海马高地', latlng: [-65.6582745198266, -56.953125], zoom: 6 },
      { name: '格鲁德山顶', latlng: [-69.5191469371798, -53.17382812500001], zoom: 6 },
      { name: '托斯迈吉亚台地', latlng: [-67.37369797436554, -52.25097656250001], zoom: 6 },
      { name: '艾美拉尔台地', latlng: [-73.15043991163012, -53.12988281250001], zoom: 6 },
      { name: '贝利尔雪原', latlng: [-71.89723806605393, -61.91894531250001], zoom: 6 },
      { name: '鲁奇玛高地', latlng: [-73.83705790733424, -62.22656250000001], zoom: 6 },
      { name: '阿盖特山', latlng: [-71.25848024041383, -70.35644531250001], zoom: 6 },
      { name: '卡尔萨谷', latlng: [-76.09023583317249, -57.48046875000001], zoom: 6 },
      { name: '西格鲁德遗迹', latlng: [-78.04379507197986, -60.55664062500001], zoom: 6 },
      { name: '西格鲁德', latlng: [-78.87004849291571, -61.21582031250001], zoom: 6 },
      { name: '卢玛琳沙丘', latlng: [-79.56850599323725, -65.25878906250001], zoom: 6 },
      { name: '龙之流放地', latlng: [-81.89845141173647, -66.92871093750001], zoom: 6 }
    ]
  }
]

const map2Text = [
  {
    name: 'one',
    children: [
      { name: '海布拉空域', latlng: [-37.718590325588146, -40.78125000000001], zoom: 3 },
      { name: '中央海拉鲁空域', latlng: [-64.16810689799152, 20.566406250000004], zoom: 3 },
      { name: '奥尔汀空域', latlng: [-40.58058466412763, 62.22656250000001], zoom: 3 },
      { name: '拉聂尔空域', latlng: [-68.65655498475736, 89.12109375000001], zoom: 3 },
      { name: '阿卡莱空域', latlng: [-32.69486597787506, 99.31640625000001], zoom: 3 },
      { name: '哈特尔空域', latlng: [-76.51681887717322, 76.81640625000001], zoom: 3 }
    ]
  },
  {
    name: 'two',
    children: [
      { name: '北阿卡莱天空诸岛', latlng: [-25.085598897064763, 95.71289062500001], zoom: 5 },
      { name: '南阿卡莱天空诸岛', latlng: [-46.70973594407156, 97.3828125], zoom: 5 },
      { name: '拉聂尔天空诸岛', latlng: [-63.48976680530999, 87.5830078125], zoom: 5 },
      { name: '南拉聂尔天空诸岛', latlng: [-73.09941313082074, 109.33593750000001], zoom: 5 },
      { name: '南奥尔汀天空诸岛', latlng: [-56.243349924105246, 61.56738281250001], zoom: 5 },
      { name: '北哈特尔天空诸岛', latlng: [-70.95952076844684, 60.20592781259637], zoom: 5 },
      { name: '哈特尔天空诸岛', latlng: [-77.8418477505252, 76.55273437500001], zoom: 5 },
      { name: '南哈特尔天空诸岛', latlng: [-82.63133285369295, 74.44335937500001], zoom: 5 },
      { name: '西哈特尔天空诸岛', latlng: [-78.14352561094756, 50.44921875000001], zoom: 5 },
      { name: '东格鲁德天空诸岛', latlng: [-78.00732483005181, -12.260742187500002], zoom: 5 },
      { name: '南海拉鲁天空诸岛', latlng: [-74.20002150558591, 7.119140625], zoom: 5 },
      { name: '初始空岛', latlng: [-73.03541866058295, 32.95898437500001], zoom: 5 },
      { name: '中央海拉鲁天空诸岛', latlng: [-64.45384948864441, 27.993164062500004], zoom: 5 },
      { name: '北海拉鲁天空诸岛', latlng: [-38.13455657705413, 32.95898437500001], zoom: 5 },
      { name: '通往天空的连绵岛屿', latlng: [-21.33031499143896, -35.02441399648313], zoom: 5 },
      { name: '东海布拉天空诸岛', latlng: [-21.493963481163405, -10.85449212148313], zoom: 5 },
      { name: '南海布拉天空诸岛', latlng: [-41.40977576599285, -34.84863274648313], zoom: 5 },
      { name: '西海布拉天空诸岛', latlng: [-36.35052693453382, -50.62499993398313], zoom: 5 },
      { name: '北格鲁德天空诸岛', latlng: [-69.19379973335275, -44.69238274648313], zoom: 5 }
    ]
  },
  {
    name: 'three',
    children: [
      { name: '北洛美城堡上层', latlng: [-19.932041306115526, 9.492187500000002], zoom: 6 },
      { name: '测试勇气之岛', latlng: [-57.504020175224646, -18.435058593750004], zoom: 6 },
      { name: '星见之岛', latlng: [-66.45188654545449, -41.70410156250001], zoom: 6 },
      { name: '时之神殿', latlng: [-70.31873847853122, 34.07958984375001], zoom: 6 },
      { name: '测试刚勇之岛', latlng: [-43.11702412135048, 29.421386718750004], zoom: 6 },
      { name: '水涌之岛', latlng: [-59.57885104663186, 93.51562500000001], zoom: 6 },
      { name: '鱼鳞飞舞之岛', latlng: [-59.44507509904714, 104.01855468750001], zoom: 6 },
      { name: '采石之岛', latlng: [-40.21244071828647, 113.62060546875001], zoom: 6 }
    ]
  }
]
const map3Text = [
  {
    name: 'one',
    children: [
      { name: '海布拉废矿', latlng: [-39.77476948529546, -39.90234375000001], zoom: 5 },
      { name: '奥尔汀废矿', latlng: [-41.11246878918086, 56.42578125000001], zoom: 5 },
      { name: '一始废矿', latlng: [-45.583289756006316, 100.01953125000001], zoom: 5 },
      { name: '拉聂尔废矿', latlng: [-56.365250136856076, 88.94531250000001], zoom: 5 },
      { name: '卡卡利科废矿', latlng: [-73.72659470212253, 63.10546875000001], zoom: 5 },
      { name: '中央大废矿', latlng: [-75.49715731893083, 4.042968750000001], zoom: 5 },
      { name: '哈特诺废矿', latlng: [-79.49665183507658, 95.80078125000001], zoom: 5 },
      { name: '沃托里废矿', latlng: [-82.14245132495608, 82.08984375000001], zoom: 5 },
      { name: '格鲁德废矿', latlng: [-79.6240562918881, -47.81250000000001], zoom: 5 }
    ]
  },
  {
    name: 'two',
    children: [
      { name: '泽卡瓦米熔岩瀑布', latlng: [-17.790535393588964, -58.18359375], zoom: 6 },
      { name: '海布拉暗化石', latlng: [-14.79612760362704, -49.19677734375001], zoom: 6 },
      { name: '明弗拉熔岩瀑布', latlng: [-15.156973713377667, -39.79248046875001], zoom: 6 },
      { name: '海布拉谷采矿场', latlng: [-28.5941685062326, -27.531738281250004], zoom: 6 },
      { name: '北洛美地下层', latlng: [-18.437924653474408, 9.689941406250002], zoom: 6 },
      { name: '古栗欧克的巢', latlng: [-24.70691524106633, 31.750488281250004], zoom: 6 },
      { name: '灼热竞技场', latlng: [-23.543845136505844, 66.62109375000001], zoom: 6 },
      { name: '阿卡莱骨冢', latlng: [-18.05186707354763, 87.923583984375], zoom: 6 },
      { name: '洛美岛地下层', latlng: [-15.538375926292048, 114.85107421875001], zoom: 6 },
      { name: '马秋兹采矿坑', latlng: [-40.4469470596005, 113.75244140625001], zoom: 6 },
      { name: '一始废矿', latlng: [-47.204642388766935, 101.689453125], zoom: 6 },
      { name: '奥尔汀废矿', latlng: [-36.43896124085946, 56.99707031250001], zoom: 6 },
      { name: '齐洛利树海', latlng: [-48.19538740833338, 45.615234375], zoom: 6 },
      { name: '克洛格树海', latlng: [-40.48038142908172, 33.15673828125001], zoom: 6 },
      { name: '密林竞技场', latlng: [-35.63944106897393, 23.13720703125], zoom: 6 },
      { name: '海布拉废矿', latlng: [-44.27667127377517, -41.48437500000001], zoom: 6 },
      { name: '古斯塔夫谷采矿场', latlng: [-62.512317938386914, 6.5478515625], zoom: 6 },
      { name: '苹果树海', latlng: [-62.12443624549497, 35.92529296875001], zoom: 6 },
      { name: '更格尔谷采矿场', latlng: [-60.88770004207789, 47.98828125000001], zoom: 6 },
      { name: '拉聂尔废矿', latlng: [-58.99531118795094, 88.681640625], zoom: 6 },
      { name: '雷兽谷采矿场', latlng: [-59.80063426102869, 98.206787109375], zoom: 6 },
      { name: '拉聂尔谷采矿场', latlng: [-73.69578033575056, 102.216796875], zoom: 6 },
      { name: '觉醒谷采矿场', latlng: [-73.7880535310551, 81.43066406250001], zoom: 6 },
      { name: '卡卡利科废矿', latlng: [-72.93898577148649, 60.33691406250001], zoom: 6 },
      { name: '时之树海', latlng: [-74.53161365108, 18.039550781250004], zoom: 6 },
      { name: '达拉伊特树海', latlng: [-72.0941892707901, -15.732421875000002], zoom: 6 },
      { name: '格鲁德谷采矿场', latlng: [-69.88501003874241, -54.64599609375001], zoom: 6 },
      { name: '阿盖特谷采矿场', latlng: [-69.61120561869633, -66.51123046875001], zoom: 6 },
      { name: '格鲁德废矿', latlng: [-80.19369416640629, -47.4609375], zoom: 6 },
      { name: '卡坡莱谷采矿场', latlng: [-79.13826033168402, 6.877441406250001], zoom: 6 },
      { name: '海利亚谷采矿场', latlng: [-77.63654163009745, 0.703125], zoom: 6 },
      { name: '娜波露谷采矿场', latlng: [-77.18155984602964, -9.404296875000002], zoom: 6 },
      { name: '勇气之源泉', latlng: [-78.70771427480673, 42.64892578125001], zoom: 6 },
      { name: '魔像制造房', latlng: [-77.41825440071796, 41.96777343750001], zoom: 6 },
      { name: '希克里树海', latlng: [-78.35384707576723, 62.70996093750001], zoom: 6 },
      { name: '花柔莉亚谷采矿场', latlng: [-79.74602141926276, 62.42431640625001], zoom: 6 },
      { name: '泰尔美谷采矿场', latlng: [-79.35147225000713, 73.41064453125001], zoom: 6 },
      { name: '席美达熔岩瀑布', latlng: [-78.22899633845603, 68.57666015625001], zoom: 6 },
      { name: '席美达谷采矿场', latlng: [-78.69479932229297, 73.69628906250001], zoom: 6 },
      { name: '洛兹伍德谷采矿场', latlng: [-77.61770905279674, 71.27929687500001], zoom: 6 },
      { name: '艾波尼谷采矿场', latlng: [-78.66892566630558, 88.98925781250001], zoom: 6 },
      { name: '哈特诺废矿', latlng: [-77.65064755611985, 93.38378906250001], zoom: 6 },
      { name: '达斯齐达谷采矿场', latlng: [-81.31495927896172, 85.34179687500001], zoom: 6 },
      { name: '克莱西亚采矿坑', latlng: [-82.59177472442023, 96.63574218750001], zoom: 6 },
      { name: '孤岛竞技场', latlng: [-82.22611461663766, 113.02734375000001], zoom: 6 },
      { name: '古代地下展望台', latlng: [-81.9447678293486, 75.21240234375001], zoom: 6 },
      { name: '柰兹坡树海', latlng: [-82.06396307846757, 18.698730468750004], zoom: 6 },
      { name: '摩尔达巴谷采矿场', latlng: [-82.25873958698165, -1.5820312500000002], zoom: 6 },
      { name: '南洛美地下层', latlng: [-82.17243329320708, -9.140625000000002], zoom: 6 },
      { name: '格鲁德地下坟场', latlng: [-82.61440515688149, -53.39355468750001], zoom: 6 },
      { name: '沙漠竞技场', latlng: [-82.87521777889144, -57.48046875000001], zoom: 6 },
      { name: '格鲁德暗化石', latlng: [-82.51202383666605, -63.45703125000001], zoom: 6 },
      { name: '沃托里废矿', latlng: [-81.67242422726376, 80.83740234375001], zoom: 6 }
    ]
  }

]
const customList = [{
  name: '资源A',
  _id: 'custom-a',
  icon_url: 'https://static-web.ghzs.com/tool/ysmap/custom/gw.png',
  points: []
}, {
  name: '资源B',
  _id: 'custom-b',
  icon_url: 'https://static-web.ghzs.com/tool/ysmap/custom/dh.png',
  points: []
}, {
  name: '资源C',
  _id: 'custom-c',
  icon_url: 'https://static-web.ghzs.com/tool/ysmap/custom/xb.png',
  points: []
}, {
  name: '资源D',
  _id: 'custom-d',
  icon_url: 'https://static-web.ghzs.com/tool/ysmap/custom/sw.png',
  points: []
}, {
  name: '资源E',
  _id: 'custom-e',
  icon_url: 'https://static-web.ghzs.com/tool/ysmap/custom/zw.png',
  points: []
}, {
  name: '资源F',
  _id: 'custom-f',
  icon_url: 'https://static-web.ghzs.com/tool/ysmap/custom/kw.png',
  points: []
}]
export {
  map1Text,
  map2Text,
  map3Text,
  customList
}
